import React from "react";

/** Avatar del asistente de IA: robot rojo con rayos, humo y movimiento. */
export const AiAvatar = ({ size = 56, busy = false, className = "" }) => (
  <span className={`ai-avatar ${busy ? "is-busy" : ""} ${className}`}
    style={{ width: size, height: size }} data-testid="ai-avatar" aria-hidden="true">
    <span className="ai-avatar-ring" />
    <span className="ai-avatar-glow" />
    <img src={`${process.env.PUBLIC_URL || ""}/ai-avatar.jpg`} alt="" className="ai-avatar-img" />
    <span className="ai-avatar-spark" />
  </span>
);

export default AiAvatar;
